<template>
  <div id="app-shell">
    <header class="site-header">
      <router-link to="/" class="brand">Alexis<span>.</span>Mayeur</router-link>
      <nav>
        <router-link to="/">Accueil</router-link>
        <router-link to="/projets">Projets</router-link>
      </nav>
    </header>
    <router-view v-slot="{ Component }">
      <transition name="page" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
    <footer class="site-footer">
      <span>&copy; {{ new Date().getFullYear() }} Alexis Mayeur</span>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    window.addEventListener('keydown', this.handleShortcut)
  },
  beforeUnmount () {
    window.removeEventListener('keydown', this.handleShortcut)
  },
  methods: {
    handleShortcut (e) {
      const tag = (e.target.tagName || '').toLowerCase()
      const isEditable = tag === 'input' || tag === 'textarea' || tag === 'select' || e.target.isContentEditable
      if (isEditable) return

      if (e.shiftKey && !e.ctrlKey && !e.altKey && !e.metaKey && e.key.toLowerCase() === 't') {
        e.preventDefault()
        if (this.$route.path !== '/admin/login') {
          this.$router.push('/admin/login')
        }
      }
    }
  }
}
</script>

<style>
:root {
  --bg: #0d1117;
  --bg-alt: #161b22;
  --border: #21262d;
  --text: #e6edf3;
  --text-dim: #8b949e;
  --accent: #3fb950;
  --accent-alt: #58a6ff;
}

* {
  box-sizing: border-box;
}

html, body {
  margin: 0;
  padding: 0;
  background: var(--bg);
}

body {
  font-family: 'Segoe UI', Avenir, Helvetica, Arial, sans-serif;
}

#app {
  color: var(--text);
}

#app-shell {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.site-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 6vw;
  border-bottom: 1px solid var(--border);
  animation: fade-in-down 0.5s ease both;
}

@keyframes fade-in-down {
  from {
    opacity: 0;
    transform: translateY(-12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fade-in-up {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.page-enter-active {
  transition: opacity 0.28s ease, transform 0.28s ease;
}

.page-leave-active {
  transition: opacity 0.16s ease;
}

.page-enter-from {
  opacity: 0;
  transform: translateY(10px);
}

.page-leave-to {
  opacity: 0;
}

.brand {
  font-family: 'Consolas', 'Courier New', monospace;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text);
  text-decoration: none;
}

.brand span {
  color: var(--accent);
}

.site-header nav {
  display: flex;
  gap: 28px;
}

.site-header nav a {
  color: var(--text-dim);
  text-decoration: none;
  font-size: 0.95rem;
  padding-bottom: 4px;
  border-bottom: 2px solid transparent;
  transition: color 0.2s ease, border-color 0.2s ease;
}

.site-header nav a:hover {
  color: var(--text);
}

.site-header nav a.router-link-exact-active {
  color: var(--accent);
  border-color: var(--accent);
}

.site-footer {
  margin-top: auto;
  padding: 24px 6vw;
  border-top: 1px solid var(--border);
  color: var(--text-dim);
  font-size: 0.85rem;
  text-align: center;
}
</style>
